function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import classnames from "classnames";
import useElements from "../hooks/useElements";
import { DropArrow } from "@wuilt/ui-components";
import { getLinkProps, MenuItemType, menuLinkWithSubAttrs } from "./ViewNavUtils";
import styles from "./NavMenu.module.scss";
function NavMenuItem(props) {
  const {
    menuItem,
    hasChildren,
    isMobile,
    className,
    isSubMenuOpen,
    onOpenSubMenu,
    onCloseSubMenu,
    navLinksColor
  } = props;
  const {
    base: {
      PageLink,
      Link
    }
  } = useElements();
  const handleOpenSubMenu = () => {
    onOpenSubMenu(menuItem);
  };
  const handleToggle = e => {
    e.preventDefault();
    e.stopPropagation();
    if (isSubMenuOpen) {
      onCloseSubMenu(menuItem);
      return;
    }
    onOpenSubMenu(menuItem);
  };
  const isFolder = menuItem.type_id === MenuItemType.Folder;
  const isPage = !menuItem.type_id || menuItem.type_id === MenuItemType.Page;
  const Component = isPage ? PageLink : isFolder ? "div" : Link;
  const {
    page,
    href
  } = getLinkProps(menuItem);
  return /*#__PURE__*/React.createElement(Component, _extends({
    page: page,
    href: href,
    id: "general-text",
    className: classnames(styles.menuItem, className)
  }, hasChildren ? menuLinkWithSubAttrs : {}, {
    onMouseEnter: !isMobile ? handleOpenSubMenu : undefined,
    target: menuItem.open_in_new_tab ? "_blank" : undefined,
    onClick: isFolder && isMobile && handleToggle,
    style: {
      color: navLinksColor
    }
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: classnames({
      [styles.levelIndent]: isMobile && menuItem.level > 0
    }),
    style: isMobile ? {
      width: 20 * menuItem.level
    } : {}
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.pageName
  }, menuItem.name || menuItem.title), hasChildren && /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.dropArrowContainer),
    onClick: isMobile && handleToggle
  }, /*#__PURE__*/React.createElement(DropArrow, {
    size: "0.8em",
    className: classnames(styles.dropArrow, {
      [styles["--active"]]: isMobile && isSubMenuOpen
    })
  }))));
}
export default NavMenuItem;
//# sourceMappingURL=NavMenuItem.js.map